import axios from "axios";
import overrideService from "./OverrideService";
import AuthAPI from "./AuthService";

////// GOOGLE //////

export const google = axios.create({
  withCredentials: false,
  baseURL: "https://maps.googleapis.com/maps/api/geocode/",
  headers: {
    "Content-Type": "application/json"
  },
});

////// CANDIDATE //////

export const candidate = axios.create({
  baseURL: window.location.origin,
  withCredentials: true, // Include _Candidate cookie
  headers: { 
    "Content-Type": "multipart/form-data" 
  }
});

////// AUTH //////

export const auth = axios.create({
  baseURL: process.env.REACT_APP_PUBLIC_GATEWAY_URL,
  crossDomain: true,
  mode: "no-cors",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Access-Control-Allow-Headers": "*",
  },
});

////// API //////

export const api = axios.create({
  baseURL: process.env.REACT_APP_PUBLIC_GATEWAY_URL,
  crossDomain: true,
  mode: "no-cors",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Access-Control-Allow-Headers": "*",
  },
});

api.interceptors.response.use(undefined, (error) => {
  return errorHandler(error);
});

api.interceptors.request.use(
  (config) => {
    overrideService.getOverride().then((res) => {
      if (res === "") return;
      var url = new URL(config.baseURL + config.url);
      url.searchParams.append("override", res);
      config.url = url.toString();
    });

    config.headers["Authorization"] = `Bearer ${localStorage.getItem(
      "JWTToken",
    )}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

const errorHandler = async (error) => {
  const statusCode = error.response?.status;
  const config = error.config;

  if (!config) {
    return Promise.reject(error);
  }

  if (config.headers) {
    delete config.headers["JWTToken"];
  }

  if (statusCode) {
    switch (statusCode) {
      case 401:
        if (config._retry) {
          return Promise.reject(error);
        }

        config._retry = true;

        try {
          let refreshPage = localStorage.getItem("Key") === null;
          await AuthAPI.authenticate();
          config.headers = config.headers ?? {};
          config.headers["Authorization"] = `Bearer ${localStorage.getItem(
            "JWTToken",
          )}`;

          const response = await api.request(config);

          if (refreshPage) {
            window.location.reload(false); // Needed on first page load if no Google API Key - allows the map to work
          }

          return response;
        } catch (authError) {
          return Promise.reject(authError);
        }
      default:
        break;
    }
  }

  return Promise.reject(error);
};